import {defineStore} from "pinia";

export const useDataFormStore = defineStore({
    id: "dataForm",
    state: () => ({
        applicationCargoPickup: {
            isCargoPickup: true,
            addressCargoPickup: "",
            pickupDate: "",

            cargoStartTimePickup: "09:00",
            cargoEndTimePickup: "18:00",
            startTimeLunchBreak: "12:00",
            endTimeLunchBreak: "13:00",

            deliveryDate: "",

            cargoStartTimeDelivery: "09:00",
            cargoEndTimeDelivery: "18:00",
            startTimeLunchBreakDelivery: "12:00",
            endTimeLunchBreakDelivery: "13:00",

            deliveryToTheAddress: false,
            addressConsignee: "",

            dataOnTheDriver: "",
            comment: "",
        },

        sender: {
            cityFrom: "",
            senderType: false,

            innSender: "",
            name: "",
            surnameSender: "",
            firstNameSender: "",
            secondNameSender: "",
            phoneSender: "",
            emailSender: "",
        },

        consignee: {
            cityTo: "",
            consigneeType: false,

            innConsignee: "",
            name: "",
            surnameConsignee: "",
            firstNameConsignee: "",
            secondNameConsignee: "",
            phoneConsignee: "",
            emailConsignee: "",
        },

        thirdPerson: {
            cargoTransportationCustomer: "",
            typeThirdPerson: false,

            innThirdPerson: "",
            name: "",
            surnameThirdPerson: "",
            firstNameThirdPerson: "",
            secondNameThirdPerson: "",
            phoneThirdPerson: "",
            emailThirdPerson: "",
        },

        cargoInformation: {
            typeOfCargo: "Стандарт",
            numberOfIdenticalLoads: 1,
            cargoVolume: null,
            cargoWeight: null,
            cargoDimensions: {
                length: null,
                width: null,
                height: null,
            },
            sizeOfCargoCylinder: {
                diameter: null,
                height: null,
            },
            additionalPackaging: false,
            typeOfPackaging: [],
            natureOfCargo: "",
            cargoCost: 3000,
        },

        services: {
            powerOfAttorney: false,
            typePowerOfAttorney: "",
            dataForTheDriver: false,
            sendTo: "",
            cashOnDelivery: false,
            cashOnDeliverySum: null,
            cargoRedemption: false,
            cargoRedemptionSum: null,
            whoPaysTheRansom: "",
            warmPlace: false,
            returnOfDocuments: false,
            isSenderInn: false
        },

        utils: {
            canGetDelivery: false
        },

        payment: {
            whoPaysForCargoDelivery: "",
            typeOfPaymentForCargoDelivery: "",
            whoPaysForCargoPickup: "",
            typeOfPaymentForCargoPickup: "",
            whoPaysForCargoTransportation: "",
            typeOfPaymentForCargoTransportation: "",
            whoPaysForCargoExtraPacking: "",
            typeOfPaymentForCargoExtraPacking: "",
            isAgreeDataProcessing: false,
            isAgreeEmailMailing: false,
        },

        calculator: {
            isCargoPickup: "",
            isDelivery: "",
            senderSklad: false,
            consigneeSklad: false,
            
        },
        applicationTimeIsOver: '13:00'
    }),
    getters: {
        getApplicationTimeIsOver(state) {
            return state.applicationTimeIsOver
        },
        getDayToDayAllowed(state) {
            const currentDate = new Date();
            const currentTimeFloat = currentDate.getHours() + currentDate.getMinutes() / 100;
            const currentFormTimeFloat = Number(state.getCheckingApplicationTimeIsOver.slice(0, 2)) + Number(state.getCheckingApplicationTimeIsOver.slice(3)) / 100
            if (currentTimeFloat >= currentFormTimeFloat) {
              return false;
            }
            return true;
        },

        getCheckingApplicationTimeIsOver(state) {
            if (state.sender.cityFrom === "Челябинск") {
                if (state.cargoInformation.cargoWeight > 30) {
                    const applicationTimeIsOver = "12:00"
                    return applicationTimeIsOver
                }
                const applicationTimeIsOver = "15:00"
                return applicationTimeIsOver
            }
            if (state.sender.cityFrom === "Екатеринбург") {
                const applicationTimeIsOver = "01:00"
                return applicationTimeIsOver
            }
            const applicationTimeIsOver = "13:00"
            return applicationTimeIsOver
        }
    },
    actions: {
        updateApplicationTimeIsOver() {
            this.applicationTimeIsOver = this.getCheckingApplicationTimeIsOver
        }
    },
});
